var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "matrix(-1, 0, 0, 1, 0, 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.49939C10.7857 5.49939 9.65119 5.83167 8.68004 6.40982C7.75056 6.96316 6.97046 7.74197 6.41557 8.67041L6.33669 8.81256L8.97987 8.05464L9.39332 9.49654L4.28753 10.9606L2.92432 6.20674L4.3662 5.79326L5.02392 8.08686L5.11519 7.92239L5.12101 7.9126C5.80399 6.76541 6.76552 5.80389 7.91273 5.12093C9.10954 4.40843 10.5082 3.99939 12 3.99939C16.4186 3.99939 20.0006 7.58138 20.0006 12C20.0006 16.4186 16.4186 20.0006 12 20.0006C9.75159 20.0006 7.71868 19.0721 6.2661 17.5796L7.34105 16.5334C8.5229 17.7478 10.1729 18.5006 12 18.5006C15.5902 18.5006 18.5006 15.5902 18.5006 12C18.5006 8.40981 15.5902 5.49939 12 5.49939Z",
    fill: "#1F2328"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 12.3086V8H12.75V11.6873L15.5016 14.4389L14.441 15.4995L11.25 12.3086Z",
    fill: "#1F2328"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.61913b9a8fe2ce2531584f62dc032aad.svg";
export { ForwardRef as ReactComponent };